// ONLY 1 CONTROLLER AND 1 MODEL.  MULTIPLE VIEWS SINCE THEY ARE MUCH BIGGER.  THIS SITS BETWEEN THE MODEL AND VIEW AND ACTS LIKE A "BRIDGE".
// events should be handled here in the controller.  Otherwise, there would be application logic in the view.  However, events need to be listened for in the view.  Otherwise, DOM elements would have to go in the controller, and presentation logic would be in the controller (goes against MVC).

// import everything in the model.  These are "named" exports since they are named.  So export everything and call it the "model".  write as model.state, model.recipe etc.

import * as model from './model.js';
import { MODAL_CLOSE_SEC } from '../js/config.js';
import recipeView from './views/recipeView.js';
// how do we pass data into the recipeView?  We create a method called "render".  Call recipeView.render and then pass in the data (which is model.state.recipe)

import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { MODAL_CLOSE_SEC } from '../js/config.js';

const controlRecipes = async function () {
  try {
    const id = window.location.hash.slice(1);

    // make a guard clause in case there are no search queries
    if (!id) return;
    // 1) load the recipe
    // this will automatically render the spinner on the recipeView.
    recipeView.renderSpinner();

    resultsView.update(model.getSearchResultsPage());

    bookmarksView.update(model.state.bookmarks);

    // async function which returns a promise.  One async function calling another async function.
    // remember that loadRecipe doesn't return anything, so there is no need to store it in a variable.
    // The recipe gets loaded and is then stored in the state object.
    await model.loadRecipe(id);

    // 2) render the recipe
    // pass in the data.  render is a common name for methods in react too.
    // model.state.recipe was received in step 1 and then passed into the render method.  Then, "render" stores it in recipeView.js in render.  And finally, that calls generateMarkup
    recipeView.render(model.state.recipe);
  } catch (err) {
    recipeView.renderError();
    console.error(err);
  }
};

// this will call async loadSearchResults.  This function is responsible for showing the search results
const controlSearchResults = async function () {
  try {
    resultsView.renderSpinner();
    // 1) get the search query
    const query = searchView.getQuery();
    if (!query) return;
    // 2) we call loadSearchResults here and load the search results
    await model.loadSearchResults(query);
    // 3) render the results.  This is coming from model.js, and we need to store the page number from getSearchResultsPage in our model.
    resultsView.render(model.getSearchResultsPage());

    // 4) render the initial pagination buttons.  This has to have a render method on it.  Pass in the ENTIRE search object.  Reference paginationView.js for the equation.
    paginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};

const controlPagination = function (goToPage) {
  // render the NEW search results
  resultsView.render(model.getSearchResultsPage(goToPage));

  // and render the NEW pagination buttons
  paginationView.render(model.state.search);
};
// this is also known as an event handler.  It's executed whenever the user changes the serving size.
const controlServings = function (newServings) {
  // let's update the recipe serving size (in the state).  The underlying data.  This will update the recipeView as well since this is impacted by clicking + or -
  model.updateServings(newServings);

  // update the recipe view
  recipeView.update(model.state.recipe);
};

const controlAddBookmark = function () {
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  recipeView.update(model.state.recipe);

  bookmarksView.render(model.state.bookmarks);
};

const controlBookmarks = function () {
  bookmarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  // show an error on the View if there is an error with try/catch
  // since the model of uploadRecipe is async, there has to be an await in here.
  try {
    addRecipeView.renderSpinner();

    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    recipeView.render(model.state.recipe);

    addRecipeView.renderMessage();

    bookmarksView.render(model.state.bookmarks);

    // this will change the id in the url, so use the history API.  Then we call the pushState method which changes the URL without re-loading the page.  It takes 3 arguments, and only the 3rd one is important since it's the URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    // this will close the form window with toggleWindow, a public function.  Give it 2.5 seconds.
    setTimeout(function () {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err);
    addRecipeView.renderError(err.message);
  }
};

// publisher/subscriber pattern
const init = function () {
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  // this will call the function in paginationView, which will in turn call addEventListner, so we can start listening fo r the click event on the pagination element.
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};

init();
